import styled from '@emotion/styled'
import theme from '~/gatsby-plugin-theme-ui'

export const CarouselWrapper = styled.div`
  .carousel-root {
    .carousel {
      overflow: hidden;
      .slide {
        background: none;
      }
      .control-dots {
        display: flex;
        flex-direction: row;
        justify-content: center;
        padding: 0px;
        margin-bottom: 12px;

        .dot {
          appearance: none;
          background-color: transparent;
          box-shadow: none;
          border: 0;
          color: transparent;
          cursor: pointer;
          display: inline-block;
          height: 28px;
          margin: 0 4px;
          opacity: 1;
          overflow: hidden;
          padding: 0;
          position: relative;
          width: 28px;

          &:before {
            background-color: ${theme.colors.white};
            border: 1px solid ${theme.colors.greyMedium};
            border-radius: 50%;
            content: '';
            display: block;
            height: 12px;
            left: 6px;
            position: absolute;
            top: 8px;
            transition: 'background-color 0.6s ease-in-out';
            width: 12px;
          }
        }

        .dot.selected:before {
          background-color: ${theme.colors.brandPrimary};
          border-color: ${theme.colors.brandPrimary};
        }
      }
    }
  }
`
